<script>
import { mapGetters } from 'vuex'
import OrderModel from '@/models/OrderModel'
export default {
  name: 'WithCustomerOrder',
  props: {
    customerId: {
      type: [String, Number],
      default: undefined,
    },
    orderId: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  async created() {
    this.loading = true
    try {
      let orderId = this.orderId || this.$route.params.orderId
      let customerId = this.customerId || this.getAuthUserId

      await OrderModel.findForCustomer(customerId, orderId)
    } catch (error) {
      this.error = `There was a problem loading your invoice`
    } finally {
      this.loading = false
    }
  },

  computed: {
    ...mapGetters('auth', ['getAuthUserId']),
    order() {
      let orderId = Number(this.orderId || this.$route.params.orderId)
      return OrderModel.query()
        .withAll()
        .where('id', orderId)
        .first()
    }, // orders
  },
  render() {
    return this.$scopedSlots.default({
      order: this.order,
      loading: this.loading,
      error: this.error,
    })
  },
}
</script>
